import type { Recording } from './types';

type RecordingSidebarProps = {
  recordings: Recording[];
  activeRecordingId: string;
  onRecordingSelect: (id: string) => void;
};

const RecordingSidebar = ({ recordings, activeRecordingId, onRecordingSelect }: RecordingSidebarProps) => {
  return (
    <div className="flex flex-col gap-4">
      <h3 className="text-lg font-bold text-slate-800">Past Sessions</h3>
      <div className="flex flex-col gap-3">
        {recordings.map((recording) => (
          <button
            key={recording.id}
            onClick={() => onRecordingSelect(recording.id)}
            className={`flex items-center gap-3 rounded-xl border p-2 transition-all hover:bg-slate-50 ${
              activeRecordingId === recording.id
                ? 'border-indigo-600 bg-indigo-50/50 ring-1 ring-indigo-600'
                : 'border-slate-100 bg-white'
            }`}
          >
            <div className="relative h-16 w-24 flex-shrink-0 overflow-hidden rounded-lg">
              <img
                src={recording.thumbnail_url}
                alt={recording.title}
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 flex items-center justify-center bg-black/20 group-hover:bg-black/40 transition">
                <svg className="h-6 w-6 text-white" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" />
                </svg>
              </div>
            </div>
            <div className="flex flex-1 flex-col items-start gap-1 overflow-hidden">
              <h4 className="w-full truncate text-left text-sm font-semibold text-slate-800">
                {recording.title}
              </h4>
              <p className="text-xs text-slate-500">{recording.coach_name}</p>
              <p className="text-xs text-slate-400">
                {new Date(recording.date).toLocaleDateString('en-US', {
                  month: 'short',
                  day: 'numeric',
                  year: 'numeric',
                })}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default RecordingSidebar;
